<template>
  <header class="header">
    <div class="main-bar">
      <div class="container">
        <div class="header-content">
          <div class="left-content">
            <a  @click="$previous()" class="back-btn">
              <svg width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.03033 0.46967C9.2966 0.735936 9.3208 1.1526 9.10295 1.44621L9.03033 1.53033L2.561 8L9.03033 14.4697C9.2966 14.7359 9.3208 15.1526 9.10295 15.4462L9.03033 15.5303C8.76406 15.7966 8.3474 15.8208 8.05379 15.6029L7.96967 15.5303L0.96967 8.53033C0.703403 8.26406 0.679197 7.8474 0.897052 7.55379L0.96967 7.46967L7.96967 0.46967C8.26256 0.176777 8.73744 0.176777 9.03033 0.46967Z" fill="#000000"/>
              </svg>
            </a>
            <h6 class="mb-0 ms-3 text-nowrap text-black">A propos de nous</h6>
          </div>
          <div class="mid-content">
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="page-content" style="height: calc(100% - 55px)">
    <div class="content-body fb">
      <div class="container">
        <h6 class="mb-3"> Fièrement propulsé par son partenaire technique </h6>
        <div class="image-menu">
          <img style="border-radius: 10px;" src="../../assets/netbyus-cover.jpg" alt="food">
        </div>
      </div>
      <div class="container px-3 bg-white shadow" style="border-radius: 30px 30px 0 0 !important;">
        <div class="text-start">
          <div class="my-3">
            <h6 class="mb-3">NetByUs</h6>
            <p class="small font-13 text-dark">
              est une société multinationale de services numériques.
              Elle fournit des solutions digitales de type applicatifs,
              logistiques et infrastructurels destinés aux entreprises,
              aux professionnels et aux particuliers.
            </p>
          </div>
          <div class="my-4">
            <h6 class="mb-3">Nous déployons des services:</h6>
            <ul class="list-style font-13">
              <li class="my-2"> Audit de stratégie digitale </li>
              <li class="my-2"> Développement et support de logiciels informatiques </li>
              <li class="my-2"> Fourniture d'équipements et outils du numérique </li>
              <li class="my-2"> Déploiement et support d'infrastructures de gestion de données </li>
            </ul>
          </div>
          <div class="row my-3">
            <h6>Nous contacter</h6>
            <div class="col-6 d-flex align-items-center my-2">
              <span class="d-flex align-items-center justify-content-center rounded-circle bg-primary" style="height: 25px; min-width: 25px">
                <i class="fa fa-phone text-white" style="font-size: 0.8em"></i>
              </span>
              <span class="small ms-2"> +229 69 79 12 12 </span>
            </div>
            <div class="col-6 d-flex align-items-center my-2">
              <span class="d-flex align-items-center justify-content-center rounded-circle bg-primary" style="height: 25px; min-width: 25px">
                <i class="fa fa-globe text-white" style="font-size: 0.8em"></i>
              </span>
              <a href="https://www.netbyus.com/" target="_blank" class="small ms-2"> www.netbyus.com </a>
            </div>
            <div class="col-6 d-flex align-items-center my-2">
              <span class="d-flex align-items-center justify-content-center rounded-circle bg-primary" style="height: 25px; min-width: 25px">
                <i class="fab fa-facebook-f fa-1x text-white" style="font-size: 0.8em"></i>
              </span>
              <a target="_blank" href="https://www.facebook.com/people/Netbyus/100068253393075/?paipv=0&eav=AfaFKbUYfRhueOPSEOSNNpLjddGKYDNJdxXQlD-RBolUY_j9SKq1bglHHV8JA_YBI1c&_rdr" class="small ms-2"> NetByUs </a>
            </div>
            <div class="col-6 d-flex align-items-center my-2">
              <span class="d-flex align-items-center justify-content-center rounded-circle bg-primary" style="height: 25px; min-width: 25px">
                <i class="fab fa-linkedin-in text-white" style="font-size: 0.8em"></i>
              </span>
              <a href="https://www.linkedin.com/company/net-by-us" target="_blank" class="small ms-2"> NetByUs </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import {usePrevious} from "@/composables/usePrevious";

const {$previous} = usePrevious()
</script>
<style scoped>
.fb {
  padding-bottom: 3em;
}
.list-style {
  margin-left: 1px!important;
  padding-left: 2em;
}

.small {
  font-stretch: condensed;
}
.small{
  text-decoration: solid;
  color: black;
  text-decoration-line: revert;
}
</style>